module.exports = __webpack_public_path__ + "media/images/checked-52756daa678a9587ea1e4147517ef135.png";